import styled from "styled-components";

export const ModalOverlay = styled.div<{ fullscreen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  ${(p) => p.fullscreen && `padding: 0;`}
  background: rgba(0, 0, 0, 0.5);
`;

export const ModalContent = styled.div<{ fullscreen: boolean }>`
  background: #fff;
  border-radius: 16px;
  width: ${(p) => (p.fullscreen ? "100vw" : "450px")};
  height: ${(p) => (p.fullscreen ? "100vh" : "auto")};
  max-width: 100vw;
  max-height: 100vh;
  overflow-y: auto;
  position: relative;
  ${(p) => p.fullscreen && `border-radius: 0;`}
`;

export const Stepper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 16px 0 12px 0;
  gap: 6px;
`;

export const StepDot = styled.div<{ active: boolean }>`
  width: ${(p) => (p.active ? "32px" : "8px")};
  height: 8px;
  border-radius: 4px;
  background: ${(p) => (p.active ? "#666" : "#E0E0E0")};
  transition: width 0.2s;
`;

export const StickyFooterSection = styled.div<{ $isDesktop: boolean }>`
  ${({ $isDesktop }) =>
    $isDesktop &&
    `
      position: sticky;
      bottom: 0;
      left: 0;
      right: 0;
      background: #fff;
      box-shadow: 0 -2px 12px rgba(0,0,0,0.08);
      z-index: 10;
    `}
`;

export const ButtonRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  padding: 16px;
`;

export const KnowMoreLink = styled.a`
  display: block;
  text-align: center;
  color: #008cff;
  font-weight: 600;
  font-size: 16px;
  margin: 16px 0 0 0;
  text-decoration: none;
`;
